export interface ResourceCache<T> {
  get: () => T | null;
  getPending: () => Promise<T> | null;
  set: (value: T) => void;
  setPending: (promise: Promise<T> | null) => void;
  clear: () => void;
}

export function createResourceCache<T>(): ResourceCache<T> {
  let value: T | null = null;
  let pending: Promise<T> | null = null;

  return {
    get: () => value,
    getPending: () => pending,
    set: (nextValue) => {
      value = nextValue;
      pending = null;
    },
    setPending: (nextPending) => {
      pending = nextPending;
    },
    clear: () => {
      value = null;
      pending = null;
    },
  };
}
